





































import { mapGetters } from "vuex";
import { bytes2Size } from "@/utils/bytes2Size";
import { App } from "@/utils/constants";

export default {
  name: "ProgressBar",
  props: {
    currentSize: {
      type: Number,
      required: true
    },
    maxSize: {
      type: Number,
      required: true
    },
    barLabel: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      App,
      bytes2Size
    };
  },

  computed: {
    ...mapGetters({
      updatedProgressBar: "updatedProgressBar",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getProgressValue() {
      return (this.currentSize / this.maxSize) * 100;
    },

    getProgressLabel() {
      const currenctSize = bytes2Size(this.currentSize),
        maxSize = bytes2Size(this.maxSize);

      return `${currenctSize}/${maxSize}`;
    },

    getBarColor() {
      const maxGreenSize = 0.6 * this.maxSize,
        maxOrangeSize = 0.9 * this.maxSize;

      if (this.currentSize < maxGreenSize) return "is-primary";
      else if (this.currentSize < maxOrangeSize) return "is-warning";
      else return "is-danger";
    }
  },

  watch: {
    getProgressValue(newValue) {
      let message = "";
      const percentage = newValue;
      if (percentage >= 50 && percentage < 75)
        message = App.ProgressBar.WARNING_50_BAR;
      else if (percentage >= 75 && percentage < 100)
        message = App.ProgressBar.WARNING_75_BAR;
      else if (percentage == 100) message = App.ProgressBar.WARNING_100_BAR;

      if (message.length)
        (this as any).snackToast.open({
          message,
          position: "is-top",
          type: "is-warning",
          duration: 8000
        });
    }
  }
};
